import { ErrorHandler } from '@angular/core';

export class MyErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

   
  handleError(error: any) {
    super.handleError(error);
  }
}
